import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip'
import { shortcut } from '@/lib/shortcuts'
import { Search } from 'lucide-react'
import { preloadCommandPalette } from './CommandPaletteHost'
import { useCommandPaletteStore } from './commandPaletteStore'

export const KBD_CLASS = 'rounded border bg-muted px-1.5 font-sans text-badge'

export function CommandPaletteTrigger() {
	const setOpen = useCommandPaletteStore(s => s.setOpen)
	return (
		<Tooltip>
			<TooltipTrigger asChild>
				<button
					type='button'
					aria-label='Search'
					className='flex h-7 w-8 shrink-0 cursor-pointer items-center justify-center rounded-md text-muted-foreground transition-colors hover:bg-sidebar-accent/50 hover:text-foreground'
					onPointerEnter={preloadCommandPalette}
					onFocus={preloadCommandPalette}
					onClick={() => setOpen(true)}
					data-testid='sidebar-command-palette-trigger'>
					<Search className='size-(--icon-standalone)' aria-hidden />
				</button>
			</TooltipTrigger>
			<TooltipContent side='bottom'>Search ({shortcut('Mod-K')})</TooltipContent>
		</Tooltip>
	)
}
